import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Main from './Main';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import Store from './redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastProvider } from './components/common/custom-toast/Toast';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_API_KEY}>
  {/* <React.StrictMode> */}
     <Provider store={Store}>
         <Main>
          <ToastProvider position="bottom-left">
           <App />
          </ToastProvider>
         </Main>
    </Provider>
  {/* </React.StrictMode> */}
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
